export function resolveRoute(pathname, posts = []) {
  if (pathname === '/') {
    return { name: 'home' };
  }

  if (pathname === '/blog/') {
    return { name: 'blog-index' };
  }

  if (pathname === '/cv' || pathname === '/cv/') {
    return { name: 'cv' };
  }

  if (pathname === '/last-nut' || pathname === '/last-nut/') {
    return { name: 'last-nut' };
  }

  if (typeof pathname !== 'string') {
    return { name: 'not-found' };
  }

  const articleMatch = pathname.match(/^\/blog\/([^/]+)\/$/);
  if (!articleMatch) {
    return { name: 'not-found' };
  }

  try {
    const slug = decodeURIComponent(articleMatch[1]);
    if (!slug || slug.includes('/')) {
      return { name: 'not-found' };
    }

    const post = posts.find(
      (candidate) => candidate.slug === slug && candidate.status === 'published'
    );

    return post ? { name: 'blog-article', post } : { name: 'not-found' };
  } catch {
    return { name: 'not-found' };
  }
}
